import { ResetPasswordDataDto } from '../dtos/reset-password-data.dto';
import { ResetPasswordData } from '../models/reset-password-data';

/**
 *  Map reset password data to dto.
 * @param {ResetPasswordData} data Reset password data.
 * @returns {ResetPasswordDataDto}
 */
function toDto(data) {
  return new ResetPasswordDataDto({
    password: data.newPassword,
    password_confirmation: data.confirmNewPassword,
  });
}

/**
 *  Map reset password data to dto.
 * @param {ResetPasswordDataDto} data Reset password data dto.
 * @returns {ResetPasswordData}
 */
function validationErrorFromDto(data) {
  return {
    newPassword: data?.password,
    confirmNewPassword: data?.password_confirmation,
  };
}

export const resetPasswordDataMapper = {
  toDto,
  validationErrorFromDto,
};
